var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarbonDirectionBear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "carbon:direction-bear-right-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 5V7.5H23.2325L15.0625 15.67C14.2473 16.4805 13.601 17.4448 13.1611 18.5069C12.7212 19.569 12.4965 20.7079 12.5 21.8575V35H15V21.8563C14.998 21.0353 15.1587 20.2222 15.4728 19.4637C15.7869 18.7053 16.2482 18.0166 16.83 17.4375L25 9.2675V17.5H27.5V5H15Z",
    fill: "#CB2129"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonDirectionBear);
export default __webpack_public_path__ + "static/media/carbon-direction-bear.08386e7e42ce8a86d6db8ad8d51a10ed.svg";
export { ForwardRef as ReactComponent };